const TYPE = `[REQUIRED DOCUMENTATION]`;

const types = {
    FETCH_START: `${TYPE} FETCH START`,
    FETCH_SUCCESS: `${TYPE} FETCH SUCCESS`,
    FETCH_ERROR: `${TYPE} FETCH ERROR`,

    UPLOAD_START: `${TYPE} UPLOAD START`,
    UPLOAD_SUCCESS: `${TYPE} UPLOAD SUCCESS`,
    UPLOAD_ERROR: `${TYPE} UPLOAD ERROR`,

    UPDATE_START: `${TYPE} UPDATE START`,
    UPDATE_SUCCESS: `${TYPE} UPDATE SUCCESS`,
    UPDATE_ERROR: `${TYPE} UPDATE ERROR`,

    DELETE_START: `${TYPE} DELETE START`,
    DELETE_SUCCESS: `${TYPE} DELETE SUCCESS`,
    DELETE_ERROR: `${TYPE} DELETE ERROR`,

    RESET_ERROR: `${TYPE} RESET ERROR`,
}

export default types;